/**
 * CountryCode enum
 */
export enum CountryCode {
  BG = 'BG',
  HR = 'HR',
  DK = 'DK',
  BE = 'BE',
  NL = 'NL',
  AU = 'AU',
  CA = 'CA',
  GB = 'GB',
  IE = 'IE',
  NZ = 'NZ',
  ZA = 'ZA',
  EE = 'EE',
  FI = 'FI',
  FR = 'FR',
  AT = 'AT',
  DE = 'DE',
  IT = 'IT',
  LV = 'LV',
  LT = 'LT',
  NO = 'NO',
  PT = 'PT',
  AR = 'AR',
  ES = 'ES',
  RU = 'RU',
  US = 'US',
  SE = 'SE',
  UA = 'UA',
  TW = 'TW',
  HK = 'HK',
  MX = 'MX',
  PR = 'PR',
  KR = 'KR',
  TH = 'TH',
  CH = 'CH',
  HU = 'HU',
  PL = 'PL',
  BR = 'BR',
  CN = 'CN',
  JP = 'JP',
  PH = 'PH',
  ID = 'ID',
  CO = 'CO',
  IN = 'IN',
  CL = 'CL',
  MY = 'MY',
  TR = 'TR',
  RE = 'RE',
  IL = 'IL',
  SG = 'SG',
  CZ = 'CZ',
  SK = 'SK',
  SL = 'SL',
  RO = 'RO',
}
